import { cx } from "class-variance-authority";
import { When } from "../when";

/**
 * @deprecated in FloKit
 */
export type ValidationProps = {
  shouldShowValidation?: boolean;
  validationMessage?: string;
  onBlur?: (e: React.FocusEvent<HTMLElement>) => void;
};

/**
 * @deprecated in FloKit
 */
export const invalidInputOutlineClasses = "outline outline-2 outline-ui-red";

const validationMessageClasses = "text-sm text-ui-red italic";

interface ValidationMessageProps extends Omit<ValidationProps, "onBlur"> {
  className?: string;
}
/**
 * @deprecated in FloKit
 */
const ValidationMessage = (props: ValidationMessageProps) => {
  return (
    <When
      condition={Boolean(props.shouldShowValidation && props.validationMessage)}
    >
      <p className={cx(validationMessageClasses, props.className)}>
        {props.validationMessage}
      </p>
    </When>
  );
};

export default ValidationMessage;
